<!-- @format -->

<div class="sidebar">
	<div class="sidebar-header">
		<!-- <img
			src="../../../assets/logo.svg"
			class="sidebar-header-img"
			alt="" /> -->
		<!-- <span class="sidebar-header-divider"></span> -->
		<span class="sidebar-header-text">SmartForms</span>
	</div>
	<nav>
		<a [class.active]="isCurrentArea(isOperatorRole ? 'dashboard' : 'home')" [attr.href]="'#' + homeMenuRoute"
			(click)="resetHomeScreen($event)" class="nav-item">
			<div class="">
				<img src="../../assets/home.svg" alt="" />
			</div>
			Home
		</a>
		<a [class.active]="isCurrentArea('analytics')" href="#/analytics" class="nav-item" *ngIf="!isOperatorRole"
			(click)="onNavClick('analytics', $event)">
			<div>
				<img src="../../assets/analytics.svg" alt="" />
			</div>
			Analytics
		</a>
		<a [class.active]="isCurrentArea('reports')" href="#/reports" class="nav-item" *ngIf="!isOperatorRole"
			(click)="onNavClick('reports', $event)">
			<div>
				<img src="../../assets/analytics.svg" alt="" />
			</div>
			Reports
		</a>
		<a [class.active]="isCurrentArea('settings')" [attr.href]="'#' + settingsMenuRoute" class="nav-item"
			(click)="onNavClick('settings', $event)">
			<div>
				<img src="../../assets/settings.svg" alt="" />
			</div>
			Settings
		</a>
	</nav>
</div>
